/* Local date for the WiseHub Radar */
(function () {
    const today = document.querySelector('[data-wh-today]');
    if (!today) return;

    const now = new Date();
    today.dateTime = now.toISOString().slice(0, 10);
    const parts = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    }).formatToParts(now);
    const values = Object.fromEntries(
        parts
            .filter((part) => part.type !== 'literal')
            .map((part) => [part.type, part.value.replace(/\./g, '')])
    );
    today.textContent = `${values.day} ${values.month} ${values.year}`.toUpperCase();
})();

/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Close the destinations panel after navigating away from it */
(function () {
    const countryMenu = document.querySelector('.wh-country-menu');
    if (!countryMenu) return;

    document.addEventListener('click', function (event) {
        if (countryMenu.open && !countryMenu.contains(event.target)) {
            countryMenu.removeAttribute('open');
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && countryMenu.open) {
            countryMenu.removeAttribute('open');
            countryMenu.querySelector('summary').focus();
        }
    });
})();

/* Editorial pathway tabs */
(function () {
    const pathways = document.querySelector('.wh-pathways');
    if (!pathways) return;

    const tabs = Array.from(pathways.querySelectorAll('[data-wh-tab]'));
    const panels = Array.from(pathways.querySelectorAll('[data-wh-panel]'));

    const activate = function (tab, moveFocus) {
        const target = tab.dataset.whTab;

        tabs.forEach(function (item) {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', String(isActive));
            item.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach(function (panel) {
            const isActive = panel.dataset.whPanel === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
        });

        if (moveFocus) {
            tab.focus();
        }
    };

    tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            activate(tab, false);
        });

        tab.addEventListener('keydown', function (event) {
            let nextIndex = null;

            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;

            if (nextIndex !== null) {
                event.preventDefault();
                activate(tabs[nextIndex], true);
            }
        });
    });

    const activateFromHash = function () {
        if (!window.location.hash) return;
        const hashTab = document.getElementById(window.location.hash.slice(1));
        if (hashTab && pathways.contains(hashTab) && hashTab.matches('[data-wh-tab]')) {
            activate(hashTab, false);
        }
    };

    activateFromHash();
    window.addEventListener('hashchange', activateFromHash);
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();
